/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { InsertLinkDialog as t } from "./insertLink.mjs";
import { InsertImageDialog as g } from "./insertImage.mjs";
import { ViewHtmlDialog as m } from "./viewHtml.mjs";
import { FindAndReplaceDialog as r } from "./FindReplace.mjs";
var i;
((e) => {
  class l extends t {
  }
  e.InsertLinkDialog = l;
  class n extends g {
  }
  e.InsertImageDialog = n;
  class s extends m {
  }
  e.ViewHtmlDialog = s;
  class o extends r {
  }
  e.FindAndReplaceDialog = o;
})(i || (i = {}));
export {
  i as EditorDialogs
};
